import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';
import moment from 'moment'

import Vue from 'vue'

const getDefaultStateForStockTransfers = () => {
  return {
    stocktransfers: [],
    data:{},
    filter:
    {
      keyword:"",
      from_location_id:"",
      to_location_id:"",
      date_from:null,
      date_to:null,
      status:"PENDING"
    },
    is_created:null,
    is_updated:null,
    is_sent:null,
    is_provisioning: null,
    is_received:null,
    is_cancelled:null
  }
}


// state
const state = getDefaultStateForStockTransfers()
// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_STOCKTRANSFERS (state) {
        Object.assign(state, getDefaultStateForStockTransfers())
    },
    FETCH_ALL(state, data)
    {
      if(data)
      {
          data.forEach(function(element) {
            element.date_requested = (element.date_requested != null && element.date_requested != '') ? (moment(element.date_requested).format('DD/MM/YYYY')) : '-',
            element.date_sent = (element.date_sent != null && element.date_sent != '') ? (moment(element.date_sent).format('DD/MM/YYYY')) : '-',
            element.date_received = (element.date_received != null && element.date_received != '') ? (moment(element.date_received).format('DD/MM/YYYY')) : '-'
         });
        state.stocktransfers = data
      }
    },
    SET_IS_RECEIVED(state, data)
    {
      state.is_received = data
    },
    SET_IS_PROVISIONED(state, data)
    { 
      state.is_provisioning = data
    },
    SET_IS_SENT(state, data)
    { 
      state.is_sent = data
    },
    FETCH(state, data) {
      state.data = data
    },
    SET_IS_CREATED(state, data){
      state.is_created = data
    },
    SET_IS_UPDATED(state, data){
      state.is_updated = data
    },
    SET_FILTER(state, data)
    {
      state.filter = data
    },
    SET_IS_CANCELLED(state, data)
    {
      state.is_cancelled = data

    }
}

// actions
const actions = {
    resetState({ commit, dispatch }, payload) {
        commit("RESET_STATE_FOR_STOCKTRANSFERS")
    },
    async create({ commit, dispatch }, data) {
      await axios.post(apiRoutes['STOCKTRANSFER_CREATE'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let doc_number  = response.data.data.code
                Vue.notify({
                    group: 'notify',
                    type: 'success',
                    text: 'Stocktransfer (' + doc_number + ')' + " has been created!",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
    
                commit('SET_IS_CREATED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CREATED', 0);
            }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
  
              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async update({ commit, dispatch }, data) {
      //alert(apiRoutes['STOCKTRANSFER_UPDATE'])
      await axios.post(apiRoutes['STOCKTRANSFER_UPDATE'], data, authHeader())
          .then(function (response) 
          {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Stocktransfer (' + doc_number + ')' + " has been updated!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_UPDATED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_UPDATED', 0);
              }
  
          })
          .catch((error) => 
          {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_UPDATED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async cancelRequest({ commit, dispatch }, data) {
      await axios.post(apiRoutes['STOCKTRANSFER_CANCEL_REQUEST'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Stocktransfer (' + doc_number + ')' + " has been cancelled!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_CANCELLED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_CANCELLED', 0);
              }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_CANCELLED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async confirmSent({ commit, dispatch }, data) {
      await axios.post(apiRoutes['STOCKTRANSFER_CONFIRM_SENT'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Stocktransfer (' + doc_number + ')' + " has been sent!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_SENT', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_SENT', 0);
              }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_SENT', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async comfirmReceived({ commit, dispatch }, data) {
      await axios.post(apiRoutes['STOCKTRANSFER_CONFIRM_RECEIVED'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Stocktransfer (' + doc_number + ')' + " has been received!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_RECEIVED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_RECEIVED', 0);
              }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_RECEIVED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Problem Receiving Request!")
              }
          });
    },
    async provisioning({ commit, dispatch }, data) {
      await axios.post(apiRoutes['STOCKCARD_CONFIRM_PROVISIONED'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
              let doc_number  = response.data.data.code
              Vue.notify({
                  group: 'notify',
                  type: 'success',
                  text: 'Stocktransfer (' + doc_number + ')' + " has been provisioned!",
                  max: 5,
                  duration: 5000,
                  speed: 300
              })
  
              commit('SET_IS_PROVISIONED', 1);
            }
            else
            {
                let errors = response.data.data.errors
                    
                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }
                commit('SET_IS_PROVISIONED', 0);
              }
  
          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)
              commit('SET_IS_PROVISIONED', 0);

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  alert("Application Error")
              }
          });
    },
    async quickSearch({ commit }, data) {
        return axios.post(apiRoutes['STOCKTRANSFER_QUICK_SEARCH'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL', response.data.data)
                commit('SET_FILTER', data)
              } 
              else 
              {
                commit('FETCH_ALL', [])
                commit('SET_FILTER', data)
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    fetch({ commit }, data) {
        return axios.post(apiRoutes['STOCKTRANSFER_RETRIEVE'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH', response.data.data)
              } else {
                commit('FETCH', {})
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    issueProvisioning({ commit }, data) {
      return axios.post(apiRoutes['ISSUE_PROVISIONING'], data, authHeader())
          .then(response => {
            if(response.data.code == 1)
            {
              commit('FETCH', response.data.data)
            } else {
              commit('FETCH', {})
            }
          })
          .catch(error => {
            if (error.response) {
              console.log(error.response)
                Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
            } else {
                console.log("Problem Querying Data!", error);
            }
        });
  }
}

export {
    state,
    getters,
    actions,
    mutations
}
